// Optional add-ons on the product page (Magnetic Case, stand): ticked ones go into the cart together
// with the product. They are added just before the product form submits, so the cart drawer that
// the form opens already shows them.
(() => {
  const root = (document.querySelector('[data-yt-addons]') || {}).closest?.('yt-product');
  if (!root) return;
  const box = root.querySelector('[data-yt-addons]');
  const addons = [...box.querySelectorAll('[data-yt-addon]')];
  const caseExclude = (box.dataset.caseExclude || '')
    .split(',')
    .map((word) => word.trim())
    .filter(Boolean);

  addons.forEach((addon) => {
    const check = addon.querySelector('[data-yt-addon-check]');
    const options = addon.querySelector('[data-yt-addon-options]');
    const json = addon.querySelector('[data-yt-addon-variants]');
    const input = addon.querySelector('[data-yt-addon-variant]');
    check.addEventListener('change', () => {
      addon.classList.toggle('is-on', check.checked);
      if (options) options.hidden = !check.checked;
    });
    if (!options || !json) return;
    const variants = JSON.parse(json.textContent);
    options.addEventListener('change', () => {
      const picked = [...options.querySelectorAll('fieldset')].map((set) => set.querySelector('input:checked')?.value);
      const match = variants.find((v) => v.options.every((value, i) => value === picked[i]));
      if (match) input.value = match.id;
      options.querySelectorAll('input').forEach((radio) => {
        const fieldset = [...options.querySelectorAll('fieldset')].indexOf(radio.closest('fieldset'));
        const test = picked.slice();
        test[fieldset] = radio.value;
        const variant = variants.find((v) => v.options.every((value, i) => value === test[i]));
        radio.closest('label').classList.toggle('is-out', !variant || !variant.available);
      });
    });
  });

  // A fixed amount discount is set in the shop currency. Shopify converts it with the plain
  // exchange rate (no rounding rules), so outside CZK the sale price is worked out here.
  const sample = box.dataset.moneySample || '';
  const formatMoney = (cents) => {
    const decimals = sample.match(/1(\D?)234(\D)56/);
    const whole = sample.match(/1(\D?)23[45]/);
    const parts = decimals || whole;
    if (!parts) return null;
    const thousands = parts[1] || '';
    let text = decimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
    let [int, dec] = text.split('.');
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    text = dec ? `${int}${decimals[2]}${dec}` : int;
    return sample.replace(parts[0], text);
  };
  const rate = Number(window.Shopify?.currency?.rate) || 0;
  box.querySelectorAll('[data-yt-addon-sale]').forEach((price) => {
    const sale = Number(price.dataset.price) - Math.round(Number(price.dataset.saveBase) * rate);
    const text = rate && sale > 0 && sale < Number(price.dataset.price) ? formatMoney(sale) : null;
    if (!text) return;
    price.textContent = text;
    price.nextElementSibling?.removeAttribute('hidden');
  });

  // The case does not fit some variants (Mini); it stays visible, greyed out and unticked.
  const caseAddon = addons.find((addon) => addon.dataset.ytAddon === 'case');
  const syncCase = () => {
    if (!caseAddon || caseAddon.hasAttribute('data-unfit-product')) return;
    const title = (root.variant?.options || []).join(' / ').toLowerCase();
    const unfit = caseExclude.some((word) => title.includes(word));
    const check = caseAddon.querySelector('[data-yt-addon-check]');
    caseAddon.classList.toggle('is-unfit', unfit);
    check.disabled = unfit;
    if (unfit && check.checked) {
      check.checked = false;
      check.dispatchEvent(new Event('change'));
    }
  };
  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-yt-variant-input]')) syncCase();
  });
  customElements.whenDefined('yt-product').then(syncCase);

  let sending = false;
  root.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (sending || !form.matches('[data-type="add-to-cart-form"]')) return;
      const items = addons
        .filter((addon) => addon.querySelector('[data-yt-addon-check]').checked)
        .map((addon) => ({ id: Number(addon.querySelector('[data-yt-addon-variant]').value), quantity: 1 }));
      if (!items.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitter = event.submitter;
      fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .catch(() => null)
        .finally(() => {
          sending = true;
          form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
          sending = false;
        });
    },
    true
  );
})();
